import { Component, OnInit, ViewChild } from '@angular/core';
import { LogService } from '../../../services/log.service';
import { ActivatedRoute } from '@angular/router';
import { BaseForm } from '../../../interfaces/BaseForm';
import { LoginService } from '../../../services/login.service';
import { Errors } from '../../../errors/errors';
import { ErrorMessage } from '../../../errors/error-message';

@Component({
  selector: 'app-confirm-code',
  templateUrl: './confirm-code.component.html',
  styleUrls: ['./confirm-code.component.scss']
})
export class ConfirmCodeComponent extends BaseForm implements OnInit {
  prompt: string;
  code: string;
  rememberDevice: boolean;
  @ViewChild('codeInput')
  codeInput;

  constructor(
    private route: ActivatedRoute,
    private log: LogService,
    private login: LoginService
  ) {
    super(log);
  }

  ngOnInit() {
    this.clear();

    // Assign title based on MFA type
    const challenge = this.login.getChallenge();
    if (challenge && challenge.isSMS_MFA()) {
      this.prompt =
        'Please enter the code sent to your phone. If you are experiencing technical difficulties, ' +
        'please contact Support at support@manifestmedex.org.';
    } else if (challenge && challenge.isTOTP_MFA()) {
      this.prompt =
        'Enter the code showing in Google Authenticator on your device';
    } else {
      this.log.error('invalid challenge encountered', challenge);
    }

    // add error handlers
    this.errorHandler.add(Errors.CODE_MISMATCH);
    this.errorHandler.add(
      Errors.EXPIRED_CODE,
      new ErrorMessage(
        'Expired authorization code. Please log in again to receive a new code.'
      )
    );
    this.errorHandler.add(Errors.LIMIT_EXCEEDED);
    this.errorHandler.add(
      Errors.NOT_AUTHORIZED,
      new ErrorMessage(
        'Too many invalid credentials attempts. Please try again after a few seconds.'
      )
    );
  }

  isValid(): boolean {
    if (this.isSubmitInProgress || !this.code) {
      return false;
    }
    return true;
  }

  clear() {
    this.code = '';
    this.codeInput.nativeElement.focus();
  }

  submit() {
    this.isSubmitInProgress = true;

    this.login.setRememberDeviceFlag(this.rememberDevice);

    this.log.trace('responding to auth challenge', this.login.getChallenge());
    this.login.respondToAuthChallenge(
      { code: this.code },
      this.onErrorCallback
    );
  }
}
